import { get, post } from '../../lib/api'
import type { PublicBadge, VerificationKind, VerificationMethod, VerificationStatus, NeedsInfoCode } from '../../../shared/market/verification'

const BASE = '/api/market/verification'
export interface CheckSummary {
  id: string
  kind: VerificationKind
  method: VerificationMethod
  status: VerificationStatus
  synthetic: boolean
  guidance: NeedsInfoCode | null
  checkedOn: string | null
  validUntil: string | null
  canStart: boolean
  canAppeal: boolean
  canRespond: boolean
  canWithdraw: boolean
  appealOpen: boolean
}
export interface VerificationStatusResponse {
  consent: { version: string; given: boolean }
  checks: Record<VerificationKind, CheckSummary | null>
  provider: { id: string; synthetic: boolean } | null
}
export interface PolicyResponse {
  consentVersion: string
  provider: { name: string; synthetic: boolean } | null
  validityDays: number
}
export interface QueueRow {
  id: string
  kind: VerificationKind
  method: VerificationMethod
  status: VerificationStatus
  displayName: string
  createdAt: number
  guidance: NeedsInfoCode | null
  appeal: boolean
  synthetic: boolean
}
export const getStatus = () => get<VerificationStatusResponse>(BASE)
export const getPolicy = () => get<PolicyResponse>(`${BASE}/policy`)
export const giveConsent = (version: string) => post(`${BASE}/consent`, { version })
export const withdrawConsent = () => post(`${BASE}/consent/withdraw`)
export const startCheck = (kind: VerificationKind, method?: VerificationMethod) => post<{ id: string; hostedUrl: string }>(`${BASE}/start`, { kind, method })
export const withdrawCheck = (id: string) => post(`${BASE}/${id}/withdraw`)
export const respondToCheck = (id: string) => post(`${BASE}/${id}/respond`)
export const appealCheck = (id: string, note: string) => post(`${BASE}/${id}/appeal`, { note })
export const getQueue = () => get<{ queue: QueueRow[] }>(`${BASE}/review`)
export const decide = (id: string, decision: 'verify' | 'decline' | 'ask_more', code?: string) => post(`${BASE}/review/${id}`, { decision, code })
export const getBadges = (itemIds: string[]) => get<{ badges: Record<string, { residency: PublicBadge | null; identity: PublicBadge | null }> }>(`${BASE}/badges?items=${itemIds.join(',')}`)
/** Local synthetic provider only: stands in for the provider's hosted page. */
export const simulate = (id: string, type: string, extra: Record<string, unknown> = {}) => post(`${BASE}/fixture/complete`, { id, type, ...extra })
